// import Swiper JS
import Swiper, { Autoplay, Navigation } from 'swiper';
// import Swiper styles
import 'swiper/css';

// configure Swiper to use modules
Swiper.use([Autoplay, Navigation]);

export function initMultiTabbedContentButtons() {
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=multi-tabbed-content-w-buttons',
      multiTabbedContentButtons
    );
  }
}

export function multiTabbedContentButtons() {
  if (!document.querySelector('.multi-tabbed-content-w-button-carousel'))
    return;

  var swiper = Swiper;
  var init = false;
  let swipertabs = document.querySelectorAll('.multi-tab-tab-alt');

  let wrapper = document.querySelector(
    '.multi-tabbed-content-w-button-carousel > .swiper-wrapper-placeholder'
  );

  let slides = wrapper.querySelectorAll('.swiper-slide-placeholder');

  function swiperMode() {
    let mobile = window.matchMedia('(max-width: 767px)');

    if (true) {
      if (!init) {
        [...slides].forEach((v, i, a) => {
          v.classList.add('swiper-slide');
          v.classList.remove('w-1/2', 'px-4');
        });
        wrapper.classList.add('swiper-wrapper');
        wrapper.classList.remove('flex-wrap', '-mb-8', '-mx-4');
        init = true;
        swiper = new Swiper('.multi-tabbed-content-w-button-carousel', {
          // Optional parameters
          slidesPerView: 1,
          slidesPerGroup: 1,
          loop: true,
          autoHeight: false,
          on: {
            init: () => {},
            slideChangeTransitionEnd: (swiper) => {
                console.log("swiped");
              [...swipertabs].forEach((v, i, a) => {
                let index = v.dataset.multiTabIndex;
                if (index == swiper.realIndex) {
                  v.classList.add('!text-mc-pink');
                  v.classList.add('!border-mc-pink');
                  v.classList.remove('text-mc-grey-extra-dark');
                } else {
                  v.classList.remove('!text-mc-pink');
                  v.classList.remove( '!border-mc-pink');
                  v.classList.add('text-mc-grey-extra-dark');
                }
              });
            },
          },
        });
      }
    } else {
      if (init) {
        swiper.destroy();
      }
      [...slides].forEach((v, i, a) => {
        v.classList.remove('swiper-slide');
        v.classList.add('w-1/2', 'px-4');
      });
      wrapper.classList.remove('swiper-wrapper');
      wrapper.classList.add('flex-wrap', '-mb-8', '-mx-4');
      init = false;
    }
  }

  swiperMode();

  window.addEventListener('resize', function () {
    swiperMode();
  });

  [...swipertabs].forEach((v, i, a) => {
    let index = v.dataset.multiTabIndex;
    v.addEventListener('click', (e) => {

      swiper.slideToLoop(index);
    });
  });

}

//   export function multiTabbedContentButtons() {
//     if (!document.querySelector('.multi-tabbed-content-w-button-carousel'))
//       return;

//     let tabs = document.querySelectorAll('.multi-tab-tab');

//     const swiper = new Swiper('.multi-tabbed-content-w-button-carousel', {
//       // Optional parameters
//       slidesPerView: 1,
//       slidesPerGroup: 1,
//       loop: true,
//       autoHeight: false,
//       on: {
//         init: () => {},
//         slideChangeTransitionEnd: (swiper) => {
//           [...tabs].forEach((v, i, a) => {
//             let index = v.dataset.multiTabIndex;

//             if (index == swiper.realIndex) {
//               v.classList.add('border-white', 'text-mc-pink');
//               v.classList.remove('border-transparent', 'text-white');
//             } else {
//               v.classList.remove('border-white', 'text-mc-pink');
//               v.classList.add('border-transparent', 'text-white');
//             }
//           });
//         },
//       },
//     });

//     [...tabs].forEach((v, i, a) => {
//       let index = v.dataset.multiTabIndex;
//       v.addEventListener('click', (e) => {
//         swiper.slideToLoop(index);
//       });
//     });
//   }
